import {NgModule} from '@angular/core'
import {BrowserModule} from '@angular/platform-browser'

import {AppRoutingModule} from './app-routing.module'
import {AppComponent} from './app.component'
import {FormsModule} from '@angular/forms'
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'

import {LoginComponent} from "./core"
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http'
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome'
import {LoadingComponent, NotificationComponent} from './core'
import {AuthInterceptor} from './core/interceptors/request.interceptor';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth'

export function tokenGetter() {
  return localStorage.getItem("access_token");
}

@NgModule({
  declarations: [
    AppComponent,
    LoadingComponent,
    NotificationComponent,
  ],
  bootstrap: [AppComponent],
  exports: [],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    LoginComponent,
    FontAwesomeModule,
    ], providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideFirebaseApp(() => initializeApp({"projectId":"maxim-portal-5f121","appId":"1:327412822608:web:972781b6ba0fb5b6fbd755","storageBucket":"maxim-portal-5f121.appspot.com","apiKey":"AIzaSyAESYgkNfeYaGo78L9VgFH3AtKFR2cIH_4","authDomain":"maxim-portal-5f121.firebaseapp.com","messagingSenderId":"327412822608","measurementId":"G-6NN0TWRNCG"})),
    provideAuth(() => getAuth()),
  ]
})

export class AppModule {

}

